export const DentalCard = () => {
  return (
    <div className="border border-[#e0e0e0] rounded-2xl p-8 max-w-4xl mx-auto">
      <div className="pb-4 border-b border-[#d0d0d0] mb-4">
        <h2 className="text-3xl font-bold text-black mb-2">Dental Plan Member</h2>
        <div className="text-base text-black">
          Show this card when accessing dental services.
        </div>
      </div>
      <div className="text-sm text-gray-600">
        Benefits vary by plan; check your plan details for coverage.
      </div>
    </div>
  );
};


